import {
  createFileRoute,
  isRedirect,
  Outlet,
  redirect,
} from "@tanstack/react-router";

import { toast } from "@/components/ui/toast";
import i18n from "@/i18n";

function showErrorToast() {
  toast.error(i18n.t("errorHandling.sessionExpired"), {
    description: i18n.t("errorHandling.sessionExpiredDescription"),
    id: "session-expired",
  });
}

export const Route = createFileRoute("/_auth")({
  component: () => <Outlet />,
  beforeLoad: async ({ context, location }) => {
    /**
     * If the user navigates directly to a protected route, this is their first stop. If
     * the keep-alive request fails, we redirect to the login form.
     *
     * We'll also make the keep-alive request on every route change in protected routes.
     * This keeps the session alive, even though we don't make other requests between steps.
     */
    const apiUrl = import.meta.env.VITE_API_URL;

    try {
      const response = await fetch(`${apiUrl}/api/Client/keep-alive`, {
        credentials: "include",
      });

      // Update the auth context with the new auth state.
      context.auth.setIsAuthenticated(response.ok);

      // If the request fails, redirect to the login form.
      if (!response.ok) {
        throw redirect({ to: "/", search: { redirect: location.href } });
      }
    } catch (error) {
      // Re-throw the redirect error so the router can handle it.
      if (isRedirect(error)) {
        showErrorToast();
        throw error;
      }

      // Handle network errors.
      showErrorToast();
      context.auth.setIsAuthenticated(false);
      throw redirect({ to: "/", search: { redirect: location.href } });
    }

    // Return the updated router context so other routes can access it.
    return context;
  },
});
